import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  currentVHStateSelector,
  selectChatState,
  ChatStates,
} from '../../slices/chat/ChatSlice';
import { usePrevious } from '../../utility/StateHooks';

const StateEntryAudio = (props) => {
  const currentVHState = useSelector(currentVHStateSelector);
  const prevVHState = usePrevious(currentVHState);
  const playedCounter = useRef(0);

  useEffect(() => {
    if (prevVHState?.id !== currentVHState?.id) {
      playedCounter.current = 0;
      if (currentVHState?.entryAudio?.url) {
        audioRef.current.loop = currentVHState?.entryAudioPlayCount === 0;
        audioRef.current.src = currentVHState?.entryAudio?.url;
        audioRef.current.volume = currentVHState?.entryAudioVolume ?? 1;
        audioRef.current.play();
        playedCounter.current = 1;
      }
    }
  }, [currentVHState, prevVHState]);

  const handleOnAudioEnded = () => {
    if (playedCounter.current < currentVHState?.entryAudioPlayCount) {
      playedCounter.current += 1;
      audioRef.current.play();
    }
  };

  const chatState = useSelector(selectChatState);
  useEffect(() => {
    if (chatState !== ChatStates.TALK && audioRef.current) {
      audioRef.current.pause();
    }
  }, [chatState]);

  const audioRef = useRef();
  return (
    <audio
      crossOrigin="anonymous"
      ref={audioRef}
      onEnded={handleOnAudioEnded}
    />
  );
};
export default StateEntryAudio;
